module.exports = __webpack_public_path__ + "static/img/3_1_2.603b78b0.jpg";